





























































































































































import Vue from "vue";
import { authentication } from "@/stores";
import { Route } from "vue-router";
import { Splash } from "@/models";
import { firestore } from "firebase/app";
import firebaseProject from "@/common/firebaseProject";
import { Collection, Document, List, DocDataRef } from "@/stores";
import { createUser, updateUser, updatePassword } from "@/stores/userUtil";
import { form, autoclose, shopBase } from "@/mixins";
import { alert, confirm } from "@/services/dialog";
import draggable from "vuedraggable";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import { default as loadImage, parseMetaData } from "blueimp-load-image";
import { v4 as Uuidv4 } from "uuid";
import dayjs from "dayjs";

const db = firebaseProject.firestore();

export default shopBase.extend(Vue).extend({
  name: "ShopsplashDetail",
  mixins: [form, autoclose],
  components: { VueCtkDateTimePicker, draggable },
  data(): {
    authentication: object;
    transitionName: string;
    justifyNow: boolean;
    imageEditor: boolean;
    uploadingFile: boolean;
    replaceIndex: number;
    editedImage: string[];
    displayNumber: number | undefined;
    displaySeconds: number | undefined;
  } {
    return {
      authentication,
      transitionName: "",
      justifyNow: false,
      imageEditor: false,
      uploadingFile: false,
      replaceIndex: -1,
      editedImage: [],
      displayNumber: undefined,
      displaySeconds: undefined
    };
  },
  async created() {
    const docId = this.$route.params.id;
    if (docId) {
      const _doc = await this.document.ref?.get();
      if (_doc) {
        this.displayNumber = _doc.data()?.displayNumber;
        this.displaySeconds = _doc.data()?.displaySeconds;
      }
    }
    if (!this.displaySeconds) {
      // デフォルト3秒
      this.displaySeconds = 3;
    }
  },
  computed: {
    collection(): Collection<Splash> {
      return new Collection(
        db.collection("splash") as firestore.CollectionReference<Splash>
      );
    },
    document(): Document<Splash> {
      const id = this.$route.params.id;
      return this.collection.doc(id, { noListen: true });
    },
    basepath(): string {
      return "shop/" + this.shopId + "/";
    },
    pageTitle(): string {
      const id = this.$route.params.id;
      return id ? "スプラッシュ詳細" : "スプラッシュ新規登録";
    },
    pageHeader(): string {
      const id = this.$route.params.id;
      return id ? "詳細" : "新規スプラッシュ";
    },
    saveButtonName(): string {
      return this.document?.data?.publishStatus != 2 ? "下書き保存" : "保存";
    }
  },
  methods: {
    async register() {
      this.document.effective.tenantId = null;
      if (this.document.effective.displayNumber != this.displayNumber) {
        this.document.effective.displayNumber = this.displayNumber;
      }
      if (this.document.effective.displaySeconds != this.displaySeconds) {
        this.document.effective.displaySeconds = this.displaySeconds;
      }
      if (
        !this.document.effective.image ||
        !this.document.effective.image.length
      ) {
        alert({
          title: "エラー",
          text: "画像を選択してください。"
        });
        return;
      }
      if (
        this.document.effective.shopId &&
        this.document.effective.shopId != this.shopId
      ) {
        alert({
          title: "エラー",
          text: "操作対象SCが異なるため、保存できません。"
        });
        return;
      }
      if (this.document.canSave) {
        this.document.effective.shopId = this.shopId;
        const result = await this.document.save().catch(e => {
          console.log(e);
          alert({
            title: "エラー",
            text: "スプラッシュの保存に失敗しました。"
          });
        });
        if (result) {
          this.$router.push("/shopsplash");
        }
      } else {
        this.$router.push("/shopsplash");
      }
    },
    async registerAndPublish() {
      this.document.effective.publishStatus = 2;
      await this.register();
    },
    async deleteDocument() {
      const result = await this.document.remove();
      if (result && result.successed) {
        this.$router.push("/shopsplash");
      } else {
        alert({
          title: "エラー",
          text: "削除できませんでした。"
        });
      }
    },
    selectImage() {
      (this.$refs.fileupload as HTMLInputElement).click();
    },
    deleteImage(index: number) {
      if (this.document?.effective.image) {
        this.document.effective.image.splice(index, 1);
        this.document.effective.image = [...this.document.effective.image];
      }
    },
    openImageEditor() {
      const images = this.document?.effective.image || [];
      this.editedImage = [...images];
      this.imageEditor = true;
    },
    closeImageEditor(save: boolean) {
      if (this.uploadingFile) {
        return;
      }
      if (save) {
        this.document.effective.image = [...this.editedImage];
      }
      this.replaceIndex = -1;
      this.imageEditor = false;
    },
    selectEditImage(index: number) {
      this.replaceIndex = index;
      (this.$refs.fileupload as HTMLInputElement).click();
    },
    deleteEditImage(index: number) {
      this.editedImage.splice(index, 1);
    },
    async uploadFile(event: Event) {
      this.uploadingFile = true;
      if (event.target instanceof HTMLInputElement) {
        if (!event.target.files || event.target.files.length <= 0) {
          alert({
            title: "エラー",
            text: "ファイルを選択、もしくは撮影してください。"
          });
          event.target.value = "";
          this.uploadingFile = false;
        } else {
          // const _this = this;
          event.target.files.forEach((item: File) => {
            loadImage(
              item,
              img => {
                //upload to firebase storage
                const _path = this.basepath + Uuidv4() + ".jpg";
                const ref = firebaseProject
                  .storage()
                  .ref()
                  .child(_path);
                const type = "image/jpeg";
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const dataUri = (img as any).toDataURL(type, 0.8);
                const bin = atob(dataUri.split(",")[1]);
                const buffer = new Uint8Array(bin.length);
                for (let i = 0; i < bin.length; i++) {
                  buffer[i] = bin.charCodeAt(i);
                }
                const blob = new Blob([buffer.buffer], { type: type });
                ref
                  .put(blob, { contentType: type })
                  .then(snapshot => {
                    return snapshot.ref.getDownloadURL();
                  })
                  .then(downloadURL => {
                    if (this.document.effective.image == undefined) {
                      this.document.effective.image = [];
                    }
                    const url = _path;
                    if (this.replaceIndex > -1) {
                      this.editedImage.splice(this.replaceIndex, 1, url);
                    } else {
                      const newArr = this.document.effective.image.slice(
                        0,
                        this.document.effective.image.length
                      );
                      newArr.push(url);
                      this.document.effective.image = newArr;
                    }
                    this.uploadingFile = false;
                  })
                  .catch(error => {
                    console.log(error);
                    this.uploadingFile = false;
                  });
              },
              {
                maxWidth: 1200,
                maxHeight: 1200,
                canvas: true
              }
            );
          });
          event.target.value = "";
        }
      }
    }
  }
});
